import React, { useState } from "react";
import downArrow from "../../assets/images/svg/angle-down-small.svg";

type VideoItem = {
  id: string;
  fileName: string;
  file?: File;
  isUploading: boolean;
  uploadProgress: number;
  facebookVideoId?: string;
  videoUrl?: string;
  thumbnailUrl?: string;
};

type VideoSelectorDropdownProps = {
  videos: VideoItem[];
  selectedVideoId: string | null;
  onVideoSelect: (videoId: string) => void;
  className?: string;
};

const VideoSelectorDropdown: React.FC<VideoSelectorDropdownProps> = ({
  videos,
  selectedVideoId,
  onVideoSelect,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Only show completed (non-uploading) videos
  const completedVideos = videos.filter(video => !video.isUploading);
  const selectedVideo = completedVideos.find(video => video.id === selectedVideoId);

  const handleVideoSelect = (videoId: string) => {
    onVideoSelect(videoId);
    setIsOpen(false);
  };

  if (completedVideos.length <= 1) {
    return null;
  }

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between ml-[-10px] lg:ml-0 gap-4 w-full h-[40px] px-3 lg:bg-[#2B2B2B] lg:border lg:border-[#2B2B2B] bg-white/10 lg:backdrop-blur-none backdrop-blur-sm lg:border-[#2B2B2B] border-0 text-white transition-colors
${isOpen ? "rounded-t-[9px]" : "rounded-[12px]"}
  `}
        style={{  fontSize: "10px" }}
      >
        <span className="truncate flex-1 text-left">
          {selectedVideo ? selectedVideo.fileName : "Select Video"}
        </span>

        <img
          src={downArrow}
          alt="Toggle"
          className={`w-[8px] h-[6px] mt-[4px] transition-transform ${isOpen ? "rotate-180" : ""
            }`}
        />
      </button>


      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full w-full ml-[-10px] lg:ml-0 left-0 right-0 lg:bg-[#1E1E1E] lg:border lg:border-[#2B2B2B] bg-white/10 lg:backdrop-blur-none backdrop-blur-sm lg:border-[#2B2B2B] border-0 rounded-b-[12px] shadow-lg z-50 max-h-40 overflow-y-auto">
          {completedVideos.map((video) => {
            const isSelected = video.id === selectedVideoId;
            return (
              <button
                key={video.id}
                onClick={!isSelected ? () => handleVideoSelect(video.id) : undefined}
                className={`w-full px-3 py-2 text-left transition-colors ${
                  isSelected
                    ? "bg-[#58F2A9] text-black cursor-default"
                    : "text-white lg:cursor-pointer hover:lg:bg-[#2B2B2B] cursor-pointer hover:bg-white/20"
                }`}
                style={{ fontSize: "10px" }}
                disabled={isSelected}
              >
                <span className="truncate block">{video.fileName}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VideoSelectorDropdown;
